import { render, staticRenderFns } from "./EventParticipantTable.vue?vue&type=template&id=12c2b458"
import script from "./EventParticipantTable.vue?vue&type=script&lang=js"
export * from "./EventParticipantTable.vue?vue&type=script&lang=js"
import style0 from "./EventParticipantTable.vue?vue&type=style&index=0&id=12c2b458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports